module.exports = __webpack_public_path__ + "static/media/face-mask-in-the-hand-SQWSWZQ.b0d74295.png";